<div>
    <div class="modal-body">
        <p class="details-description voucher-confirm-header">Would you like to submit a voucher?</p>
    </div>
    <div class="modal-footer footer-container">
        <button type="button" class="btn btn-default" (click)="back.emit()">BACK</button>
        <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
        <button type="button" class="btn btn-primary" (click)="submitVoucher()">SUBMIT</button>
    </div>
</div>
